import "../../company.css";
import ProductPartners from "../../../../components/product-partners";
import JoinUsHero from "../components/join-us-hero";
import LifeAtAcube from "../components/life-at-acube";
import EmployeeCarousel from "../../../../components/carousels/employee-carousel";
import JoinUsForm from "../../../../components/forms/joinus-form";

const JoinUs = () => {
  return (
    <section className="join-team-wrapper">
      <JoinUsHero />
      <LifeAtAcube />
      <EmployeeCarousel />
      <JoinUsForm />
      <ProductPartners />
    </section>
  );
};

export default JoinUs;
